export default __webpack_public_path__ + "static/media/being_developed.ec613e45.svg";